export class DebiCheckModel {
    id?: number;
    branchName: string;
    branchSerial: string;
    deviceName: string;
    deviceSerial: string;
    merchantNumber:string;
    updatedBy: any;
}
